import React, { useEffect, useState } from 'react'
import AntdTable from '@/components/table/AntdTable'
import { downLoadFileBlob, formatMessageNew } from '@/utils/common'
import { exportObClaimEpc, getObClaimEpcList } from '@/services/rfid/reports/obClaimReport'

const ObClaimEpcModalTable = ({ selectItem = {} }) => {
  const [tableList, setTableList] = useState([])

  const tableColumns = [
    {
      title: formatMessageNew('languageObj.obClaimReport.productCode'),
      dataIndex: 'productCode',
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: formatMessageNew('languageObj.obClaimReport.size'),
      dataIndex: 'size',
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: formatMessageNew('languageObj.obClaimReport.epc'),
      dataIndex: 'epcList',
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: formatMessageNew('languageObj.obClaimReport.factoryCode'),
      dataIndex: 'factoryCodeStr',
      render: text => <div className="word_break_all">{text}</div>
    }
  ]

  useEffect(() => {
    if (!selectItem || !selectItem.plant) {
      setTableList([])
      return
    }
    getObClaimEpcList({
      plant: selectItem.plant,
      upc: selectItem.upc,
      cartonNo: selectItem.cartonNo,
      productCode: selectItem.productCode,
      productSize: selectItem.size
    }).then(res => {
      const dt = (res && res.resultData) || []
      setTableList(dt)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectItem])

  const downLoadFun = () => {
    exportObClaimEpc({
      plant: selectItem.plant,
      upc: selectItem.upc,
      cartonNo: selectItem.cartonNo,
      productCode: selectItem.productCode,
      productSize: selectItem.size
    }).then(res => downLoadFileBlob(res))
  }

  return (
    <div className="auto-mt30">
      <AntdTable
        rowKey={(record, index) => index}
        dataSource={tableList}
        columns={tableColumns}
        onDownload={downLoadFun}
        pagination={false}
      />
    </div>
  )
}

export default ObClaimEpcModalTable
